<template lang="pug">
  form#email_signup.klaviyo-form(
    :class="embedClass",
    data-ajax-submit="//manage.kmail-lists.com/ajax/subscriptions/subscribe",
    action='//manage.kmail-lists.com/subscriptions/subscribe',
    method='GET',
    target="_blank",
    accept-charset='UTF-8',
    _lpchecked='1',
    @submit='showMessaging'
  )
    input(type='hidden', name='form_type', value='customer')
    input(type='hidden', name='g', :value='listId')

    transition(name="slideOut")
      text-input.klaviyo-form__input(
        v-if="notSubmitted"
        type="email",
        name="email",
        id="k_id_email",
        value="",
        label="Email Address",
        error-text="You must enter a valid email"
        :placeholder="placeholder",
        autocorrect="off",
        autocapitalize="off",
        autocomplete="email",
        v-model="emailInput"
        required
        aria-label="Email"
        icon="arrow-right"
        icon-is-submit-button
        width="20px"
        height="20px"
        hide-label
        email-capture
      )
    transition(name="slideIn")
      p.contact-form__success(v-if="isSuccess && message") {{ message }}
</template>

<script>
  import TextInput from 'scripts/components/forms/TextInput.vue';
  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    name: 'KlaviyoForm',
    components: {
      TextInput,
      Icon,
    },
    props: {
      message: String,
      listId: String,
      placeholder: String,
    },
    data() {
      return {
        isSuccess: false,
        notSubmitted: true,
        emailInput: '',
      };
    },
    computed: {
      embedClass() {
        return `klaviyo_embed_${this.listId}`;
      },
    },
    mounted() {
      const klaviyoInterval = setInterval(() => {
        // eslint-disable-next-line no-undef
        if (KlaviyoSubscribe) {
          clearInterval(klaviyoInterval);

          // eslint-disable-next-line no-undef
          KlaviyoSubscribe.attachToForms(this.$el, {
            hide_form_on_success: false,
          });
        }
      }, 500);
    },
    methods: {
      showMessaging() {
        this.notSubmitted = false;
        setTimeout(() => {
          this.isSuccess = true;
        }, 500);
      },
    },
  };
</script>

<style scoped lang="scss">
  .klaviyo-form__input {
    margin: 0;
    max-width: unset;
  }
</style>
